import LoginModal from '~/components/layouts/navigation/LoginModal';
import CompanyModal from '~/components/layouts/navigation/CompanyModal';
import AccountModal from '~/components/layouts/navigation/bottomMenu/AccountModal';
import { useUser } from '~/modules/useUser';
import BottomMenu from './bottomMenu/BottomMenu';
import TopMenu from './TopMenu';
import type { Configuration } from './TopMenu';

const Navbar = ({ configuration }: { configuration: Configuration }) => {
  const clientStore = useUser();

  return (
    <>
      <TopMenu configuration={configuration}/>
      {configuration.showBottomNav && <BottomMenu />}
      <LoginModal />
      <CompanyModal />
      {clientStore !== null && <AccountModal />}
    </>
  );
};

export default Navbar;
